import React, { useState, useEffect, Fragment } from "react";
import AdminDashboard from "../../AdminDashboard";
import { dict } from "../../../../dictionary";
import { default_url } from "../../../..";
import { isAuthenticated } from "../../../../auth";
import { listLists, deleteList} from "../../apiAdmin"
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'


function ListsAdmin() {
    const [lists, setLists] = useState([]);
    const [deletedItem, setDeletedItem] = useState({
        name: "",
        id: "",
        success: false
    });
    const [show, setShow] = useState(false);

    const { user, token } = isAuthenticated();

    const loadLists = () => {
        listLists().then(res => {
            if (res.error) {
                console.log(res.error);
            } else {
                setLists(res);
            }
        });
    }

    useEffect(() => {
        loadLists();
    }, [])

    const handleClose = () => {
        setShow(false);
    }
    const handleShow = (event) => {
        setShow(true);
        setDeletedItem({ name: event.target.name, id: event.target.id })
    }
    const handleDelete = (event) => {
        event.preventDefault();
        handleClose();
        deleteList(deletedItem.id, user._id, token).then(res => {
            if (res.error) {
                console.log(res.error);
            } else {
                loadLists();
                setDeletedItem({ ...deletedItem, success: true });
            }
        })
    }

    const clickSubmit = target => () => {
        if(target == "add"){
            window.location.href = default_url + "admin/lists/add"
        }else if(target == "replace"){
            window.location.href = default_url + "admin/offers/replace"
        }
        
    }

    const popUp = () => {
        return (
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{dict["deleting_product"]}</Modal.Title>
                </Modal.Header>
                {
                    default_url == "/en/" && <Modal.Body style={{ textAlign: "start" }}>{"Are you sure you want to delete " + deletedItem.name + " from offers?"}</Modal.Body>
                }
                {
                    default_url == "/ar/" && <Modal.Body style={{ textAlign: "start" }}>{"هل انت متأكد تريد ازالة المنتج " + deletedItem.name + " من قائمة العروض؟"}</Modal.Body>
                }
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        {dict["close"]}
                    </Button>
                    <Button variant="primary" onClick={handleDelete}>
                        {dict["delete"]}
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }

    const showAlert = () => {
        if (deletedItem.success) {
            return (
                <div
                    className={"alert alert-info alert-dismissible fade show"}
                    role="alert"
                >
                    <h2 style={{ textAlign: "start" }}>{dict["list_has_been_deleted"]}</h2>
                    <button type="button" className="close alertCloseBtn" data-dismiss="alert" aria-label="Close" style={{ left: default_url == "/ar/" ? "0" : "auto", right: default_url == "/ar/" ? "auto" : "0" }}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            )
        }
    }

    const allLists = () => {
        return (
            lists.sort((a, b) => a.order - b.order).map((item, index) => {
                return (
                    <div key={index} className={"dataContainer " + (index === lists.length - 1 ? "lastDataContainer" : "")}>
                        <span className="dataContainerNumber" style={{ float: default_url == "/en/" ? "left" : "right" }}>{item.order}</span>
                        <span className="dataContainerTitle" style={{ float: default_url == "/en/" ? "left" : "right" }}>{default_url == "/ar/" ? item.arName : item.enName}</span>
                        <a className="dataContainerAction"
                            href="#"
                            onClick={handleShow}
                            name={default_url == "/ar/" ? item.arName : item.enName}
                            id={item._id}
                            style={{ float: default_url == "/en/" ? "right" : "left" }}
                        >{dict["delete"]}</a>
                        {popUp()}
                        <a className="dataContainerAction" href={default_url + "admin/lists/edit?list_id=" + item._id} style={{ float: default_url == "/en/" ? "right" : "left" }}>{dict["edit"]}</a>
                    </div>
                )
            })
        )
    }

    const showEmpty = () => {
        return (
            <h1 style={{ textAlign: "start" }}>{dict["no_products_found"]}</h1>
        )
    }

    const form = () => {
        return (
            <div className="userProfileDataContainer">
                {showAlert()}
                <h3 className="formContainerTitle">{dict["lists"]}</h3>
                {lists.length > 0 ? allLists() : showEmpty()}
                <button onClick={clickSubmit("add")} type="submit" className="dashboardBtn" style={{ marginInlineEnd: "2.5%"}}>{dict["add_new_list"]}</button>
            </div>
        )
    }

    return (
        <AdminDashboard
            active="7"
            data={form}
            categories={[]}
            subcategories={[]}
            newOrders={0}
        />
    )
}

export default ListsAdmin;